
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { useCookies } from 'react-cookie';
import useFetch from "./FetchHook";
import { useNavigate } from "react-router-dom";
import ReactLoading from 'react-loading';


const Update = () => {
  const { id } = useParams();
  const [cookies] = useCookies(["token"]);
  const token = cookies.token;
  const navigate= useNavigate();
  const [isLoading, setIsLoading] = useState(false); // New state variable


const { data, pending, Error } = useFetch(
  "https://campus-closet-server.vercel.app/items/products/"+id
);
  const [formData, setFormData] = useState({
    productCategory: "Select Category",
    productName: "",
    productDescription: "",
    productPhoto: null,
    price: "",
  });
  useEffect(()=>{
    { data &&  setFormData({
        productCategory: data[0].product_category,
        productName: data[0].product_name,
        productDescription: data[0].description,
        productPhoto: null,
        price: data[0].price
      })}
  },[id, data])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    setFormData((prevFormData) => ({
      ...prevFormData,
      productPhoto: file,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true); 

    const formDataToSend = new FormData();
    formDataToSend.append('productCategory', formData.productCategory);
    formDataToSend.append('productName', formData.productName);
    formDataToSend.append('productDescription', formData.productDescription);
    formDataToSend.append('productPhoto', formData.productPhoto);
    formDataToSend.append('price', formData.price);

    fetch(`https://campus-closet-server.vercel.app/products/${id}`, {
      method: "PUT", // Use PUT method to update the product
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formDataToSend,
    })
      .then((res) => {
        setIsLoading(false); 
        if (res.ok) {
          console.log('Product Updated successfully');
          toast.success("Product Updated successfully!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          setFormData({
            productCategory: "",
            productName: "",
            productDescription: "",
            productPhoto: null,
            price: ""
          })
          setTimeout(() => {
            navigate('/Admin');
          }, 3000);
        } else {
          console.log('Error in adding the product');
          toast.error("Error updating the product!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
        return res.json();
      })
      .then((data) => {
        // Handle the response data
      })
      .catch((error) => {
        setIsLoading(false); 
        console.log(error);
        toast.error("Error updating the product!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      });
  };
if (pending) {
  return (
  <div className="min-h-screen flex justify-center items-center bg-gray-100">
    <div className="text-xl font-semibold text-gray-600">Loading...</div>
  </div>
  );
}
if (Error) {
  return (
  <div className="min-h-screen flex justify-center items-center bg-gray-100">
  <div className="bg-white p-8 rounded-md shadow-md text-center">
    <p className="text-xl font-semibold mb-4">
      Oops! An error occurred while fetching product information 😕
    </p>
    <p className="text-lg text-gray-600">
      Try again later or contact support for assistance.
    </p>
    {/* You can also add a button or link to navigate back or reload the page */}
    {/* For example: */}
    <button
      className="mt-4 mr-5 bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      onClick={() => window.location.reload()}
    >
      Retry
    </button>
    <button
      className="mt-4 bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      onClick={() => navigate('/admin')}
    >
      Back
    </button>
  </div>
</div>
  );
}
  return (
    <section>
        {isLoading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 opacity-50">
          <div>
            <ReactLoading type="spinningBubbles" color="#ffffff" height={80} width={80} />
            <p className="text-white">This may take a little while!</p>
          </div>
        </div>
      )}
      <div className="my-4 flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <div className="form w-full bg-white rounded-lg shadow dark:border md:mt-0  sm:max-w-md xl:p-0 ">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
              Add Your Product Here
            </h1>
            <form
                className="space-y-4 md:space-y-6 "
                onSubmit={handleSubmit}
              >
                <div>
                  <label
                    htmlFor="productCategory"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Product Category
                  </label>
                  <select
                    name="productCategory"
                    id="productCategory"
                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                    required
                    value={formData.productCategory}
                    onChange={handleChange}
                  >
                    <option value="">Select Category</option>
                    <option value="HouseHolds">HouseHolds</option>
                    <option value="Electronics">Electronics</option>
                    <option value="Funitures">Fanitures</option>
                    <option value="Others">Others</option>
                  </select>
                </div>

                <div>
                  <label
                    htmlFor="email"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Product Name
                  </label>
                  <input
                    type="text"
                    name="productName"
                    id="productName"
                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                    placeholder="Name of your Product"
                    required
                    value={formData.productName}
                      onChange={handleChange}
                  />
                </div>
                <div>
                  <label
                    htmlFor="email"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Product Descriptions
                  </label>
                  <input
                    type="text"
                    name="productDescription"
                    id="productDescription"
                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                    placeholder="Tell Us more about your product"
                    required
                    value={formData.productDescription}
                      onChange={handleChange}
                  />
                </div>
                <div>
                  <label
                    htmlFor="photo"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Product Photo
                  </label>
                  <input
                    type="file"
                    name="productPhoto"
                    id="productPhoto"
                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                    required
                    onChange={handlePhotoUpload}
                  />
                </div>

                <div>
                  <label
                    htmlFor="password"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Price
                  </label>
                  <input
                    type="text"
                    name="price"
                    id="price"
                    placeholder="eg ksh. 1000"
                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:focus:border-blue-500"
                    required
                    value={formData.price}
                      onChange={handleChange}
                  />
                </div>
                <button
                  type="submit"
                  className="w-full text-gray-900 bg-blue-400 hover:bg-blue-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  Upload
                </button>
              </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default Update;
